import React, { useEffect, useState } from "react";
import CustomButton from "../shared/CustomButton";
import {
  CAMPAIGN_OPTION_WALLET_TYPE,
  ChevronRight,
  formatNumber,
  getCartTotalValue,
  getCartWalletType,
  getCartWalletIsFixedType,
  prefix,
  ShoppingCart02,
  withContainers,
  cartIsAllowed,
} from "../normalizer";
import {
  CampaignUserContainer,
  ShoppingCartContainer,
} from "../../containers/gamification2026";
import CartWarning from "./CartWarning";
import CartItemsQuantityInput from "./CartItemsQuantityInput";
import { ToastService } from "../shared/Toast";
import CartCheckoutModal from "./shared/CartCheckoutModal";
import CoPaymentModal from "./shared/CoPaymentModal";
import PaymentMethodsModal from "./shared/PaymentMethodsModal";
import CartResultModal from "./CartResultModal";

const tCartCheckout = prefix("cart-checkout");

const CartContainer = (props) => {
  const {
    cart,
    campaign,
    campaignUser,
    currencyLabel,
    onSetItemQuantity,
    onIncreaseItem,
    onDecreaseItem,
    onRemoveItem,
    checkout,
    onCheckCartItem,
    getUserCheckoutRestrictions,
    checkingEnd,
    onCheckout,
    allDigitalCards,
    cartResult = {},
    onResultOk
  } = props;
  const [showAlert, setShowAlert] = useState(false);
  const [
    showCoPaymentConditionsModal,
    setShowCoPaymentConditionsModal,
  ] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [showPaymentMethodsModal, setShowPaymentMethodsModal] = useState(false);
  const [shouldUseCoPayment, setShouldUseCoPayment] = useState(false);
  const [acceptCoPaymentConditions, setAcceptCoPaymentConditions] = useState(
    false,
  );
  const [currentStage, setCurrentStage] = useState(0);
  const [userHasNoPoints, setUserHasNoPoints] = useState(false);
  const [checkoutStages, setCheckoutStages] = useState([
    "checking-points",
    "checking-percentage",
    "checking-cart",
    "checking-terms",
    "choosing-payment-method",
    "checking-end",
  ]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [hasEnoughPoints, setHasEnoughPoints] = useState(false);
  const [overcomeMaxPercentage, setOvercomeMaxPercentage] = useState(false);
  const [restingPoints, setRestingPoints] = useState(0);
  const [noCoPaymentItems, setNoCoPaymentItems] = useState([]);
  const [debtPoints, setDebtPoints] = useState(0);
  const [allowCoPayments, setAllowCoPayments] = useState(false);

  
  const [allowed, setAllowed] = useState(false);
  const [toRemove, setToRemove] = useState([]);

  useEffect(()=>{
    const {allowed, toRemove } = cartIsAllowed(cart)
    setAllowed(allowed)
    setToRemove(toRemove)
  }, [cart])

  // The cart may only move on to the address step when it fits the user's
  // point balance; `availablePoints` is the authoritative figure.
  const missingPoints =
    campaignUser && campaignUser.availablePoints !== undefined
      ? cart.total_points - campaignUser.availablePoints
      : 0;

  const onCheckCart = () => {
    if (!allowed && !!toRemove.length)
      ToastService.error(tCartCheckout("checkout-alert-products"));
    else if (missingPoints > 0)
      ToastService.error(tCartCheckout("user-has-not-enough-points"));
    else onCheckCartItem()
  }


  const editCartItems = !checkout;
  const showMonetaryValue =
    getCartWalletType(cart) === CAMPAIGN_OPTION_WALLET_TYPE &&
    getCartWalletIsFixedType(cart) === false;

  const shipment_address = cart.shipment_address;
  // Digital-only orders carry no shipment address; contacts come from the
  // dedicated contacts step instead.
  const contactInfo = allDigitalCards
    ? cart.contacts || {}
    : shipment_address || {};

  useEffect(() => {

    const filterNoCoPaymentProducts = (items) =>
      items.filter((item) => !item.product.accepts_co_payment);

    const maximum_percentage = cart.payment_definitions
      ? cart.payment_definitions.maximum_percentage
      : 0;

    const noCoPaymentItems = filterNoCoPaymentProducts(cart.items);

    const {
      userHasNoPoints,
      hasEnoughPoints,
      overcomeMaxPercentage,
      restingPoints,
      debtPoints,
    } = getUserCheckoutRestrictions(
      campaignUser.availablePoints,
      campaignUser.total_points,
      cart.payment_definitions.maximum_percentage,
    );

    setAllowCoPayments(cart.allows_co_payments);
    setUserHasNoPoints(userHasNoPoints);
    setHasEnoughPoints(hasEnoughPoints);
    setOvercomeMaxPercentage(overcomeMaxPercentage);
    setRestingPoints(restingPoints);
    setDebtPoints(debtPoints);
    setNoCoPaymentItems(noCoPaymentItems);
  }, [cart, campaignUser]);

  useEffect(() => {
    if (checkingEnd) {
      setAlertMsg(campaign.confirmation_message);
    }
  }, [checkingEnd, campaign]);

  const openAlertModal = () => {
    if (userHasNoPoints && !allowCoPayments) {
      ToastService.error(tCartCheckout("user-has-no-points"));
    } else if (!hasEnoughPoints && !cart.allows_co_payments) {
      ToastService.error(tCartCheckout("user-has-not-enough-points"));
    } else {
      setShowAlert(true);
      setShowCoPaymentConditionsModal(true);
    }
  }

  const closeAlertModal = () => {
    setShowAlert(false);
  };

  const openCoPaymentConditionsModal = () => {
    setShowAlert(false);
    setShowCoPaymentConditionsModal(true);
  };

  const closeCoPaymentConditionsModal = () => {
    setShowCoPaymentConditionsModal(false);
  };

  const openPaymentMethodsModal = () => {
    setShowAlert(false);
    setShowCoPaymentConditionsModal(false);
    setShowPaymentMethodsModal(true);
  };

  const closePaymentMethodsModal = () => {
    setShowPaymentMethodsModal(false);
  };

  const handleAcceptCoPaymentConditions = (e) => {
    e.preventDefault();
    const { target } = e;

    setAcceptCoPaymentConditions(target.checked);
    setShowAlert(true);
    setShowCoPaymentConditionsModal(false);
    setShowPaymentMethodsModal(true);
    setCurrentStage(nextStage());
  };

  const goToTermsStage = () => {
    setShowAlert(false);
    setShowCoPaymentConditionsModal(true);
    setCurrentStage(nextStage());
  };

  const goToFinalStage = () => {
    setCurrentStage(5);
  };

  const goToNextStage = () => {
    setCurrentStage(nextStage());
  };

  const goToPreviousStage = () => {
    setCurrentStage(previousStage());
  };

  const previousStage = () => {
    return (currentStage - 1) % checkoutStages.length;
  };

  const nextStage = () => {
    return (currentStage + 1) % checkoutStages.length;
  };

  const handleShouldUseCoPayment = () => {

    setShowCoPaymentConditionsModal(true);
    setShouldUseCoPayment(true);
    setCurrentStage(nextStage());
  };

  const handleWishRemoveProducts = () => {

    setCurrentStage(nextStage());
    setRedirect(true);
  };

  const handleChoosePaymentMethod = (method) => {

    setShowAlert(true);
    setShowCoPaymentConditionsModal(false);
    setSelectedPaymentMethod(method);
    setCurrentStage(nextStage());
  };

  const handleModalCancellationAction = () => {
    closeAlertModal();
  };

  const renderFinalModal = () => {
    const content = {
      title: tCartCheckout("checkout-alert-title"),
      msg: tCartCheckout("checkout-alert-message")
    };

    const coPaymentParams = {
      shouldUseCoPayment,
      acceptCoPaymentConditions,
      selectedPaymentMethod,
    };

    return (
      <CartCheckoutModal
        selected={showAlert}
        content={content}
        onAccept={() => { closeAlertModal(); onCheckout(coPaymentParams);}}
        onNoAccept={handleModalCancellationAction}
      />
    );
  };

  const renderHasNotEnoughPointsModal = () => {
    const content = {
      alertMsg: tCartCheckout("insuficient-points").replace(
        "{points}",
        Math.abs(debtPoints),
      ),
      items: null,
      shouldUseCoPayment: false,
    };

    return (
      <CartCheckoutModal
        selected={showAlert}
        content={content}
        onAccept={handleShouldUseCoPayment}
        onNoAccept={handleModalCancellationAction}
      />
    );
  };

  const renderOvercomeMaxPercentageModal = () => {
    const content = {
      alertMsg: tCartCheckout("exceeded-percentage").replace(
        "{restingPoints}",
        Math.abs(Math.floor(restingPoints * 100) / 100),
      ),
      items: null,
      shouldUseCoPayment: false,
    };

    return (
      <CartCheckoutModal
        selected={showAlert}
        content={content}
        onAccept={handleWishRemoveProducts}
        onNoAccept={handleModalCancellationAction}
      />
    );
  };

  const renderWithNoCoPaymentProductsModal = () => {
    const content = {
      alertMsg: tCartCheckout("products-dont-allow-co-payment"),
      items: noCoPaymentItems,
      shouldUseCoPayment: true,
    };

    return (
      <CartCheckoutModal
        selected={showAlert}
        content={content}
        onAccept={handleWishRemoveProducts}
        onNoAccept={handleModalCancellationAction}
      />
    );
  };

  const renderCoPaymentTermsModal = () => {
    return (
      <CoPaymentModal
        show={showCoPaymentConditionsModal}
        close={closeCoPaymentConditionsModal}
        paymentDefinitions={cart.payment_definitions}
        conditionsAccepted={acceptCoPaymentConditions}
        handleAcceptConditions={handleAcceptCoPaymentConditions}
      />
    );
  };

  const renderChoosePaymentMethodModal = () => {
    return (
      <PaymentMethodsModal
        show={showPaymentMethodsModal}
        close={closePaymentMethodsModal}
        campaignRate={campaign.rate}
        debtPoints={Math.abs(debtPoints)}
        paymentMethods={cart.paymentMethods}
        handleMethodChoosing={handleChoosePaymentMethod}
      />
    );
  };

  const renderCheckoutModal = () => {
    return currentStage === 0
      ? !hasEnoughPoints
        ? renderHasNotEnoughPointsModal()
        : goToFinalStage()
      : currentStage === 1
      ? overcomeMaxPercentage
        ? renderOvercomeMaxPercentageModal()
        : goToNextStage()
      : currentStage === 2
      ? noCoPaymentItems.length > 0
        ? renderWithNoCoPaymentProductsModal()
        : goToTermsStage()
      : currentStage === 3
      ? renderCoPaymentTermsModal()
      : currentStage === 4
      ? renderChoosePaymentMethodModal()
      : renderFinalModal();
  };

  return (
    <div className="cart-container">
      <div className="cart-container-content">
        {checkout && (
          <div className="cart-container-header">
            <div className="cart-container-header-title">Prémios</div>
          </div>
        )}
        <div className="cart-container-prizes">
          {cart.items.map((item, index) => {
            return (
              <div key={item.id} className="cart-container-prize">
                <div className={"cart-container-prize-image"}>
                  <img
                    className={
                      "cart-container-prize-image-image" +
                      (checkout ? " checkout" : "")
                    }
                    src={item.product.main_image.url}
                    alt={item.product.name}
                  />
                </div>
                <div className="cart-container-prize-info">
                  <div
                    className={
                      "cart-container-prize-name" +
                      (checkout ? " checkout" : "")
                    }
                  >
                    {item.product.name}
                  </div>
                  <div
                    className={
                      "cart-container-prize-points" +
                      (checkout ? " checkout" : "")
                    }
                  >
                    {showMonetaryValue
                      ? `${formatNumber(item.points)} pontos = ${formatNumber(item.value)}€`
                      : `${formatNumber(item.points)} pontos`}
                  </div>
                  {!editCartItems && (
                    <div className="cart-container-prize-units">
                      {item.quantity}{" "}
                      {item.quantity > 1 ? "unidades" : "unidade"}
                    </div>
                  )}
                  {editCartItems && (
                    <div className="cart-container-prize-quantity">
                      <CartItemsQuantityInput
                        item={item}
                        onSetItemQuantity={onSetItemQuantity}
                        onIncreaseItem={onIncreaseItem}
                        onDecreaseItem={onDecreaseItem}
                        onRemoveItem={onRemoveItem}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {checkout && (
          <div className="cart-container-customer-info">
            {!allDigitalCards && shipment_address && (
              <div className="cart-container-customer-info-address">
                <div className="cart-container-customer-info-address-title">
                  Morada
                </div>
                <div className="cart-container-customer-info-address-info">
                  <div className="cart-container-customer-info-address-info-address">
                    {shipment_address.address1}, {shipment_address.address2}
                  </div>
                  <div className="cart-container-customer-info-address-info-postalcode">
                    {shipment_address.city}, {shipment_address.zip_code}
                  </div>
                  <div className="cart-container-customer-info-address-info-country">
                    {shipment_address.country.name}
                  </div>
                </div>
              </div>
            )}
            <div className="cart-container-customer-info-contacts">
              <div className="cart-container-customer-info-contacts-title">
                Contactos
              </div>
              <div className="cart-container-customer-info-contacts-info">
                <div className="cart-container-customer-info-contacts-info-email">
                  {contactInfo.email}
                </div>
                <div className="cart-container-customer-info-contacts-info-phone">
                  {contactInfo.phone}
                </div>
              </div>
            </div>
          </div>
        )}
        {campaign && campaign.call_attention ? (
          <CartWarning text={campaign.call_attention} />
        ) : null}
      </div>
      <div className="cart-container-checkout">
        <ShoppingCart02 className="cart-container-checkout-icon" />
        <div className="cart-container-checkout-group">
          <div className="cart-container-checkout-title1">Total</div>
          <div className="cart-container-checkout-total">
            {showMonetaryValue
              ? `${formatNumber(cart.total_points)} pontos = ${formatNumber(getCartTotalValue(cart))}€`
              : `${formatNumber(cart.total_points)} pontos`}
          </div>
        </div>
        <div className="cart-container-checkout-group">
          <div className="cart-container-checkout-title2">
            Pontos disponíveis
          </div>
          <div className="cart-container-checkout-available-points">
            {formatNumber(campaignUser.availablePoints)} pontos
          </div>
        </div>
        {!checkout && onCheckCartItem  ? (
          <CustomButton
            className="cart-container-checkout-button"
            onClick={() => onCheckCart()}
          >
            Avançar
            <ChevronRight />
          </CustomButton>
        ) : null}
        {checkout  && (
          <CustomButton
            className="cart-container-checkout-button"
            onClick={() => openAlertModal()}
          >
            Avançar
            <ChevronRight />
          </CustomButton>
        )}
        {campaignUser && cart.total_points > campaignUser.availablePoints && (
          <CartWarning
            header={`${formatNumber(cart.total_points - campaignUser.availablePoints)} pontos em falta`}
            text="Os pontos em falta serão pagos por copagamento"
          />
        )}
      </div>
        {renderCheckoutModal()}
        <CartResultModal
          show={cartResult.show}
          success={cartResult.success}
          message={cartResult.message}
          onOk={onResultOk}
        />
    </div>
  );
};

export default withContainers(CartContainer, [
  CampaignUserContainer,
  ShoppingCartContainer,
]);

